import axios from '@/plugins/api.request'

/**
 * 列表
 * @param {*} params
 */
export const list = (params) => {
  return axios.request({
    method: 'get',
    url: 'message/list',
    params
  })
}

/**
 * 消息已读
 * @param {*} params
 */
export const read = (params) => {
  return axios.request({
    method: 'get',
    url: 'message/read',
    params
  })
}

/**
 * 未读数量
 * @param {*} params
 */
export const unreadCount = (params) => {
  return axios.request({
    method: 'get',
    url: 'message/unread',
    params
  })
}

/**
 * 删除消息
 * @param {*} params
 */
export const del = (params) => {
  return axios.request({
    method: 'get',
    url: 'message/del',
    params
  })
}

/**
 * 获取动态
 * @param {*} data
 */
export const getDynamic = (params) => {
  return axios.request({
    method: 'get',
    url: 'message/dynamic',
    params
  })
}